(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-back-to-top]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const toggle = header.querySelector('[data-mobile-nav-toggle]');
    const mobileNav = header.querySelector('[data-mobile-nav]');
    const panel = header.querySelector('[data-mobile-nav-panel]');
    const backdrop = header.querySelector('[data-mobile-nav-backdrop]');

    if (!toggle || !mobileNav || !panel) return;

    const openLabel = toggle.dataset.openLabel || 'Open menu';
    const closeLabel = toggle.dataset.closeLabel || 'Close menu';

    const setNavTop = () => {
      const height = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--mobile-nav-top', `${height}px`);
    };

    const closeMenu = () => {
      header.classList.remove('site-header--menu-open');
      mobileNav.classList.remove('mobile-nav--open');
      mobileNav.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', openLabel);
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.removeAttribute('scroll-lock');
    };

    const openMenu = () => {
      setNavTop();
      header.classList.add('site-header--menu-open');
      mobileNav.hidden = false;
      mobileNav.classList.add('mobile-nav--open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', closeLabel);
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.setAttribute('scroll-lock', '');
    };

    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      } else {
        openMenu();
      }
    });

    backdrop?.addEventListener('click', closeMenu);

    mobileNav.querySelectorAll('[data-mobile-nav-link]').forEach((link) => {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
        toggle.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 768 && toggle.getAttribute('aria-expanded') === 'true') {
        closeMenu();
      } else if (toggle.getAttribute('aria-expanded') === 'true') {
        setNavTop();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-project-gallery]').forEach((gallery) => {
    const lightbox = gallery.querySelector('[data-gallery-lightbox]');
    const fullsize = gallery.querySelector('[data-gallery-fullsize]');
    const closeButton = gallery.querySelector('[data-gallery-close]');

    if (!lightbox || !fullsize) return;

    gallery.querySelectorAll('[data-gallery-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const url = trigger.dataset.fullsizeUrl;
        if (!url) return;

        fullsize.src = url;
        fullsize.alt = trigger.getAttribute('aria-label') || '';
        lightbox.showModal();
      });
    });

    closeButton?.addEventListener('click', () => lightbox.close());

    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });

    lightbox.addEventListener('close', () => {
      fullsize.removeAttribute('src');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
